// src/types/client.ts

import type { NexusModule, PricingTier } from "./modules";

export interface Client {
  id: string;
  name: string;
  slug?: string; // URL-safe identifier, stored in DB
  shortName?: string; // Optional short display name
  primaryContactName?: string;
  primaryContactEmail?: string;
  notes?: string;

  // Brand identity
  logo_url?: string; // Client logo for visual recognition
  brand_color?: string; // Primary brand color (hex format)

  // Module configuration
  enabledModules: NexusModule[];
  pricingTier: PricingTier;
  moduleSettings?: Record<string, unknown>; // Per-module settings

  // Demo and protection flags
  isDemo?: boolean; // True for demo organizations
  isProtected?: boolean; // True to prevent deletion/mutation

  // Metadata
  createdAt: number;
  updatedAt: number;
}

/**
 * Convert a client name to a URL-safe slug
 * Example: "Regional Food Bank" -> "regional-food-bank"
 */
export function clientNameToSlug(name: string): string {
  return name.toLowerCase().replace(/\s+/g, "-");
}

/**
 * Get the slug for a client
 * Returns the stored slug if available, otherwise computes it from the name
 */
export function getClientSlug(client: Client): string {
  return client.slug || clientNameToSlug(client.name);
}
